import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Gift, Copy, Share2 } from "lucide-react";

export default function ReferralCard() {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/referral/me").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  if (!info) return null;
  const url = `${window.location.origin}/inscription?ref=${info.code}`;
  const copy = async () => { try { await navigator.clipboard.writeText(url); toast.success("Lien de parrainage copié"); } catch { toast.error("Copie impossible"); } };
  return (
    <div className="mt-6 sc-card" data-testid="referral-card">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Gift className="w-5 h-5 text-rose-500" /> Parrainer un coach</h2>
      <p className="text-sm text-slate-600 mt-1">Pour chaque coach inscrit avec votre lien : <b>1 mois de Coach Pro offert</b> pour vous et pour lui.</p>
      <div className="mt-3 flex gap-2 items-center">
        <input data-testid="referral-url" readOnly value={url} className="flex-1 border border-slate-200 rounded-xl p-2 text-xs bg-slate-50 font-mono" onFocus={(e) => e.target.select()} />
        <button data-testid="referral-copy" onClick={copy} className="sc-btn sc-btn-outline text-xs"><Copy className="w-4 h-4" /></button>
        <a data-testid="referral-whatsapp" href={`https://wa.me/?text=${encodeURIComponent(`Rejoins-moi sur TymCoach, on gagne chacun 1 mois Coach Pro : ${url}`)}`} target="_blank" rel="noreferrer" className="sc-btn text-xs bg-[#25D366] text-white border-0"><Share2 className="w-4 h-4" /></a>
      </div>
      <div className="mt-2 text-xs text-slate-500" data-testid="referral-stats">Code <b className="font-mono">{info.code}</b> · {info.referrals_count} filleul(s) · {info.credits} mois offert(s) en attente</div>
    </div>
  );
}
